import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Form, FormHiddenNumber, FormSubmitBack, FormText } from '../../../../../../shared/form/form'
import { IconAdd } from '../../../../../../shared/icon/icon'
import { useApiFormNodeCourse } from '../../../../../../api-new/state/content'
import { useDataContext } from '../data-context'

export const NodeCourseAdd = ({ parentURL, parentID }) => {
  const history = useHistory()

  const dataContext = useDataContext()

  const apiFormNodeCourse = useApiFormNodeCourse()

  const handleSubmit = async data => {
    await apiFormNodeCourse.post(data)
    await dataContext.reload()
    history.push(parentURL)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="add">
        <CardFullHeightScrollY title="course add">
          <Form onSubmit={handleSubmit}>
            <FormHiddenNumber name="parentID" value={parentID} />
            <FormText label="name" name="name" autoFocus />
            <FormSubmitBack text="create course" />
          </Form>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
